import { btnDelay } from "common/utils";
import i18n from "features/shared/i18n";
import { ParentPiece } from "features/player/types";
import { ParentPieceCard } from "./ParentPieceCard";

interface PiecesSectionProps {
  pieces: ParentPiece[];
  onSelectPiece: (piece: ParentPiece) => void;
  onShowMore: () => void;
}

export const PiecesSection = ({ pieces, onSelectPiece, onShowMore }: PiecesSectionProps) => {

  return (
    <div className="bg-white rounded-[16px] p-6">
      <div className="flex-row-el items-center justify-between mb-5 pb-3 border-b border-outline">
        <div className="flex-row-el items-center gap-2 text-[24px] text-textcolor-black">
          <span className="material-symbols-outlined !text-[45px] text-red-100">extension</span>
          {i18n.t("MSG_PARENT_PAGE_PLAYER_PIECES")}
          <span className="text-[21px] font-normal text-gray2-100 ml-1">({pieces.length})</span>
        </div>
        {pieces.length > 5 && (
          <button
            className="flex-row-el items-center gap-1 px-4 py-2 bg-white border border-gray2-60 rounded-full text-[21px] text-textcolor-black cursor-pointer hover:bg-gray2-20 transition-all"
            onClick={() => {
              btnDelay(onShowMore);
            }}
          >
            {i18n.t("MSG_PARENT_PAGE_PLAYER_SHOW_MORE")}
          </button>
        )}
      </div>

      {pieces.length > 0 ? (
        <div className="w-full overflow-x-auto invisible-scrollbar">
          <div className="flex-row-el gap-4 pb-2 w-max">
            {pieces.slice(0, 5).map((piece) => (
              <ParentPieceCard
                key={piece.piece_id}
                piece={piece}
                onClick={() => {
                  btnDelay(() => onSelectPiece(piece));
                }}
              />
            ))}
          </div>
        </div>
      ) : (
        <div className="flex-col-center py-8 text-gray2-100">
          <span className="material-symbols-outlined text-[60px] mb-2">extension</span>
          <span className="text-[21px]">{i18n.t("MSG_PARENT_PAGE_PLAYER_PIECES_EMPTY")}</span>
        </div>
      )}
    </div>
  );
};
